<template>
  <div class="header-container">
<b-container class="no-margin">
    <b-row>
<h1 class="p-color">fashion for change</h1>
    </b-row>
</b-container>
<b-container class="header-padding">
    <h3>Position: <span class="p-color">🤸‍♂ UX Designer</span></h3>
    <h3> Project: <span class="p-color">💻 Website Re-Design</span></h3>
    <h3>Company: <span class="p-color">✊ Non-Profit</span></h3>
    <h3> Timeline: <span class="p-color heading-padding">⏰ November 2017 - June 2018</span></h3>
  <h2 class="header-padding"><a class="link" target="_blank" href="http://fashionforchange.ca">fashionforchange.ca</a></h2>
</b-container>
<b-container>
  <b-row class="header-padding">
  <b-col cols="12" sm="12" md="4" lg="4" xl="4">
 <h4><span class="heading5">Introduction</span></h4>
<p>I joined Fashion for Change in 2017 and stayed with the team until the end of the school year. I stayed on during my exchange, where I would have to be up at all times of the night to make our meetings. </p>
  </b-col>
    <b-col cols="12" sm="12" md="8" lg="8" xl="8">
         <b-img rounded class="image-size" :src="fc_about_us" img-alt="This is a screenshot of the Fashion for Change website, this is the About Us page."></b-img>
    </b-col>
  </b-row>
    </b-container>
          <b-container class="middle-margin">
        <b-row>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <h4><span class="heading5">Objectives</span></h4>
<ul>
<li>Refresh Website on a new platform (get off of Wordpress)</li>
<li>Attract new sponsors</li>
<li>Create a platform for attendees to get more information</li>
<li>Renew the job application process</li>
<li>Have a better way to showcase media</li>
<li>Create a place for old shows to live</li>
<li>Create a blog</li>
<li>Make a responsive website</li>
</ul>
 </b-col>
 <b-col cols="12" sm="12" md="6" lg="6" xl="6">
       <h4><span class="heading5">Achievements</span></h4>
       <ul>
<li>New Website designed using Webflow and Contentful</li>
<li>Sponsor page reupdated with new look and feel</li>
<li>Website has new copy and more information</li>
<li>Job Application process is cleaned up</li>
<li>Shows are now listed in order and all fit the same format</li>
<li>Blog links to Medium</li>
<li>Fully responsive</li>
       </ul>
 </b-col>
 </b-row>
 </b-container>
  <b-container class="middle-margin header-padding">
 <h4><span class="heading5">About</span></h4>
 <p>Fashion for Change is a non-profit organization based at the University of Waterloo and Wilfred Laurier University. It’s the largest student-run charity in the Kitchener - Waterloo region. They raise up to $20,000 the WE Villages Program. </p>

</b-container>
      <b-container class="header-padding">
      <b-row>
      <b-col cols="12" sm="12" md="8" lg="8" xl="8">
         <b-img rounded class="image-size" :src="fc_page_preview_gif" img-alt="This is another screenshot of the completed Fashion for Change website, here is the landing page."></b-img>
    </b-col>
    <b-col cols="12" sm="12" md="4" lg="4" xl="4">
    <h4><span class="heading5">Goals</span></h4>
  <p>In November of 2017, I was hired onto their design team to work on a re-design of their website. Their old website was designed over 5 years ago. It didn’t adapt to different screen sizes, needed a branding and general refresh.</p>
    </b-col>
    </b-row>
      </b-container>
      <b-container class="middle-margin header-padding">
   <h2 class="header-padding"><a class="font-deco"> Our team of 3 was tasked with re-designing the user experience, the general design, the job application process, and improving sponsor information.</a></h2>
      </b-container>
      <b-container>
  <b-row class="header-padding">
 <b-col cols="12" sm="12" md="4" lg="4" xl="4">
  <h4><span class="heading5">My Role</span></h4>
<p>I was hired on as the User Experience Designer. As part of my role, I worked on improving the site architecture, the user experience, and I introduced the initial design feel that we ended up implementing. </p>
 </b-col>
  <b-col cols="12" sm="12" md="8" lg="8" xl="8">
   <b-img rounded class="image-size" :src="fc_roles" img-alt="This is a third screenshot of the completed Fashion for Change website, it shows the available positions."></b-img>
 </b-col>
 </b-row>
      </b-container>
      <b-container class="middle-margin header-padding">
  <h4><span class="heading5">Old Site Review</span></h4>
  <p>One of the first things we did as part of our re-design was to analyze the old website and figure out what problems people were running into. To do this we did user testing with potential customers and user groups. Some of the things we noticed were that many of the users complained first and foremost about the design. It is simply unappealing and very outdated. A second thing that people had difficulty with was finding information, there is a disconnect between the information that we were trying to communicate and what the website was showing. Other insights included difficulty applying to jobs and finding information for sponsors. </p>
<h2 class="header-padding"><a class="font-deco">"I had no idea how to find anything." - UW Student</a></h2>
</b-container>
<b-container class="header-padding">
<b-row>
  <b-col cols="12" sm="12" md="4" lg="4" xl="4">
   <b-img rounded class="image-size" :src="fc_home" img-alt="This is a screenshot of the original website's landing page. It lacks color, and feel to it."></b-img>
  </b-col>
    <b-col cols="12" sm="12" md="4" lg="4" xl="4">
   <b-img rounded class="image-size" :src="fc_about" img-alt="This is a screenshot of the original websites about us page. It is cluttered and the spacing is broken."></b-img>
  </b-col>
    <b-col cols="12" sm="12" md="4" lg="4" xl="4">
   <b-img rounded class="image-size" :src="fc_job" img-alt="This is a screenshot of the original website's available positions, it is hard to understand because it shows all the possible positions rather than specific ones."></b-img>
  </b-col>
  </b-row>
  </b-container>
  <b-container class="middle-margin header-padding">
    <h4><span class="heading5">Users and Personas</span></h4>
    <p>As part of our research and strategy, we designed several different user personas. As you can see these ranged in the type of person we are trying to target, from students to sponsors. </p>
</b-container>
<b-container>
     <b-row class="image-padding">
  <b-col cols="12" sm="12" md="4" lg="4" xl="4">
   <b-img rounded class="image-size" :src="dorothy" img-alt="This is an image of one of the possible users: Dorothy"></b-img>
  </b-col>
  <b-col cols="12" sm="12" md="8" lg="8" xl="8">
   <h3>Dorothy</h3>
   <p>Dorothy recently started school at the University of Waterloo and loves fashion. She wants to do more on campus, but is not sure what happens on campus. She recently heard about a fashion show that takes place on campus, but upon visitng the website is very confused. </p>
  <h5>Goals</h5>
  <ul>
  <li>Learn about new Fashion for Change Events on campus</li>
  <li>Wants to help the world</li>
  <li>Experience a live fashion show</li>
  </ul>
  <h5>Frustrations</h5>
  <ul>
    <li>Doesn't want to scour social media for information</li>
    <li>Website is convoluted and ugly</li>
    <li>Website is very confusing</li>
  </ul>
  </b-col>
     </b-row>
     <b-row class="image-padding">
    <b-col cols="12" sm="12" md="4" lg="4" xl="4">
   <b-img rounded class="image-size" :src="jennifer" img-alt="This is an image of one of the possible users: Jennifer"></b-img>
   <p class="image-paragraph"></p>
  </b-col>
   <b-col cols="12" sm="12" md="8" lg="8" xl="8">
   <h3>Jennifer</h3>
<p>Jennifer started her clothing line 5 years ago. It has grown substantially. She is looking to grow her client base into the universities and hopes to attract students. </p>
  <h5>Goals</h5>
  <ul>
  <li>Have more brand recognition</li>
  <li>Increase her client base in Kitchener-Waterloo</li>
  <li>Use University groups to increase brand recognition</li>
  </ul>
  <h5>Behaviours</h5>
  <ul>
    <li>Likes a communicative and discussion based clients</li>
    <li>Tech-Savvy</li>
    <li>Wants to know how a partnership will help her</li>
  </ul>
  </b-col>
</b-row>
</b-container>
<b-container class="middle-margin header-padding">
      <!-- <h4><span class="heading5">New Site Organization</span></h4>
      <p>The first step to our redesign we creating a new site organization. We needed to reorganize the old version. It was too complicated. We aimed to have several tabs at the top with more information falling into the pages. </p> -->
        <h4><span class="heading5">Design Stages</span></h4>
        <p>The design of the website went through several iterations. We started with concepts and move towards a more streamlined design. I would say my designs were very creative and I really tried to break the mold with them. I encouraged us to do a more landing page style for the pages as they would be able to give information and attract our target the best. </p>
</b-container>
<b-container>
       <b-row>
  <b-col cols="12" sm="12"  md="3" lg="3" xl="3">
       <h4>Version 1</h4>
   <b-img rounded class="image-size" :src="fc_landing_v1" img-alt="
This is the first mockup that I created for the Fashion for Change website, I was trying to create a look and feel and push the idea of a long landing page. This version is dark, with large icons."></b-img>
  </b-col>
    <b-col cols="12" sm="12"  md="3" lg="3" xl="3">
        <h4>Version 2</h4>
   <b-img rounded class="image-size" :src="fc_landing_v2" img-alt="This is the second version that I created. This version has a white background and more photos than the first. I was experimenting with large text."></b-img>
  </b-col>
    <b-col cols="12" sm="12"  md="3" lg="3" xl="3">
        <h4>Version 3</h4>
   <b-img rounded class="image-size" :src="fc_landing_v3" img-alt="This is the third version, much of the second is followed here, but the text size is reduced and the spacing is improved."></b-img>
  </b-col>
      <b-col cols="12" sm="12" md="3" lg="3" xl="3">
          <h4>Final Version</h4>
   <b-img rounded class="image-size" :src="fc_landing_final" img-alt="This is the final version of the website, in this version, the text and image spacing is much cleaner with more white space available. We also added highlight boxes behind the text to bring that text out more."></b-img>
  </b-col>
  </b-row>
  <b-row align-h="center">
<h2 class="header-padding"><a class="link" target="_blank" href="http://fashionforchange.ca">fashionforchange.ca</a></h2>
  </b-row>
     <b-img rounded class="image-size" :src="fc_sponsor" img-alt="This is a screenshot of the sponsor page, it features different tiers of possible sponsorship."></b-img>
</b-container>
  <b-container>
    <h4 class="header-padding"><span class="heading5">Other Projects</span></h4>
      <b-row>
            <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <router-link to="/snapsuite">
          <b-card class="hvr-grow margin-on-card card-text card-size" title="SnapSuite Inc - Internship Position" :img-src="snapsuite" img-alt="Image of a macbook pro with the home page of an app I designed for SnapSuite." img-top>
                <p class="card-text">
      Customer portal for companies to create work orders. From concept to final working product.
    </p>
          </b-card>
          </router-link>
    </b-col>
        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <router-link to="/veganambition">
          <b-card class="hvr-grow margin-on-card card-text card-size" title="The Vegan Ambition - Podcast Host" :img-src="projectImage" img-alt="Image of an iPhone Ten with the homepage of The Vegan Ambition on it." img-top>
                <p class="card-text">
      The Vegan Ambition is a podcast looking to change the discourse about veganism.
                </p>
          </b-card>
          </router-link>
    </b-col>
        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <router-link to="/glide">
          <b-card class="hvr-grow margin-on-card card-text card-size" title="Glide - Capstone Project" :img-src="glide" img-alt="Image of an iPhone with the logo of Glide on it." img-top>
                <p class="card-text">
      Glide is a task-based daily scheduling application for employees with ASD and their managers.
                </p>
          </b-card>
          </router-link>
    </b-col>
  </b-row>
  </b-container>

  </div>
</template>

<script>
export default {
  data () {
    return {
      dorothy: './../../static/images/fashionForChange/dorothy.jpg',
      jennifer: './../../static/images/fashionForChange/Jennifer.jpg',
      fc_home: './../../static/images/fashionForChange/fcHomePage001.jpg',
      fc_about: './../../static/images/fashionForChange/fcAboutPage001.jpg',
      fc_job: './../../static/images/fashionForChange/fcJobPage001.jpg',
      fc_logo: './../../static/images/fashionForChange/logoBlack2x.jpg',
      fc_landing_v1: './../../static/images/fashionForChange/FCLandingPagev1.jpg',
      fc_landing_v2: './../../static/images/fashionForChange/FCLandingV2.jpg',
      fc_landing_v3: './../../static/images/fashionForChange/FCLandingV3.jpg',
      fc_landing_final: './../../static/images/fashionForChange/FCLandingFinal.jpg',
      fc_page_preview_gif: './../../static/images/fashionForChange/fcNewWebsite.jpg',
      fc_roles: './../../static/images/fashionForChange/fcRoles.jpg',
      fc_about_us: './../../static/images/fashionForChange/fcNewAboutUs.jpg',
      fc_sponsor: './../../static/images/fashionForChange/fcSponsor.jpg',
      glide: './../../static/images/homePage/GlideMockups2.png',
      fashionForChange: './../../static/images/homePage/FashionForChange.jpg',
      snapsuite: './../../static/images/homePage/snapsuite.jpg',
      projectImage: './../../static/images/homePage/theveganambition.jpg'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Righteous");

h1 {
  font-family: "Righteous", cursive;
  font-size: 100px;
          padding-left: 25px;
    padding-right: 10px;
}
h4{
  padding-top:20px;
  padding-bottom:5px;
}
h2{
  font-weight: 800;
}
.font-deco{
  background: linear-gradient(to bottom, transparent 62%, #187BC2 0) center center/0% 75% no-repeat;
  padding: 0 6px 2px 6px;
    background-size: 100% 100%;
}
.header-padding{
  padding-top:40px;
}
.image-padding{
  margin-top:60px;
}
.image-padding2{
  margin-top:30px;
    margin-bottom: 60px;
}
.header-container {
  width: 100%;
}
.no-margin {
  padding-left: 0px;
  padding-right: 0px;
}
.image-paragraph{
  font-size:14px;
  color: #6D6E71;
  margin-top: 5px;

}
.link {
  color: #000000;
  text-decoration: underline;
  font-weight: 600;
  text-decoration-color: #187BC2;
  -webkit-transition: color 0.7s; /* For Safari 3.0 to 6.0 */
  transition: color 0.7s; /* For modern browsers */
      transition: background-size .4s ease;
  background: linear-gradient(to bottom, transparent 62%, #187BC2 0) center center/0% 75% no-repeat;
  padding: 0 6px 2px 6px;
}
.link:hover {
  background-size: 100% 100%;
  color: #000000;
}
.heading5 {
      color: #6D6E71;
      font-size: 18px;
      text-transform: uppercase;
      font-weight: 700;
}
.card-text {
  color: black;
}
.margin-on-card {
  margin-bottom: 20px;
}
.hvr-grow {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
}
.hvr-grow:hover, .hvr-grow:focus, .hvr-grow:active {
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}
.image-size{
  width:100%;
  padding:0px !important;
  margin: 0px !important;
}
.middle-margin{
  padding-left: 160px;
  padding-right: 160px;
}
@media screen and (max-width: 992px) {
h1{
    font-size: 100px;
            padding-left: 25px;
    padding-right: 10px;
}
h2{
  font-size:26px;
}
h3{
  font-size: 25px;
}
  .middle-margin{
  padding-left: 40px;
  padding-right: 40px;
}
.image-size{
  width:100%;
  margin-bottom: 10px !important;
}
.image-padding2{
  margin-top:0px;
    margin-bottom: 40px;
}
}

/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 600px) {
h1{
    font-size: 65px;
        padding-left: 25px;
    padding-right: 10px;
}
h2{
  font-size:24px;
}
h3{
  font-size: 25px;
}
.header-padding{
  padding-left:10px;
  padding-right:10px;
}
.middle-margin{
  padding-left: 10px;
  padding-right: 10px;
}
.image-size{
  width:100%;
  margin-bottom: 10px !important;
}
.image-padding2{
  margin-top:0px;
    margin-bottom: 40px;
}
}

@media screen and (max-width: 400px) {
h1{
    font-size: 63px;
    padding-left: 25px;
    padding-right: 10px;
}
h3{
  font-size:20px;
}
h2{
  font-size:22px;
}
.header-padding{
  padding-left:10px;
  padding-right:10px;
}
.middle-margin{
  padding-left: 10px;
  padding-right: 10px;
}
.image-size{
  width:100%;
  margin-bottom: 10px !important;
}
.image-padding2{
  margin-top:0px;
  margin-bottom: 40px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/fashionforchange.vue